import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodUsername = ZodTrimmedString.regex(/^[a-z0-9_]*$/)
  .min(3)
  .max(15);
